import ReactDOM from 'react-dom';
import React, { useState, useEffect } from 'react';
import './App.css';
import Wrapper from './Components/Wrapper';
import Logo from './images/logo.png'
import FireImage from "./images/firewood.jpg"
import Bottom from "./images/stack.jpg"
import Products from './Components/Products';

function App() {

  const [page, setPage] = useState("home");

  function handleChange() {
    setPage("contact");
    console.log(page)
  }

  return (
    <div className="App" >
      <header className="App-header">
      </header >
      <div class="container">

        <div class="row">
          <div class="col">
            <nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top d-flex flex-row-reverse bd-highlight">
              <a href="#" class="navbar-brand">
                <span class="text-uppercase font-weight-bold d-none d-sm-inline-block">Brookline Firewood</span>
                <img src={Logo} width="100" alt="" class="d-inline-block align-middle ml-4"></img>
              </a>

              <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
              </button>

              <div class="collapse navbar-collapse" id="navbarText">
                <ul class="navbar-nav mr-auto">
                  <li class="nav-item active">
                    <a class="nav-link" href="#" onClick={() => setPage("home")}>Home</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#" onClick={() => setPage("process")}>Our Process</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#" onClick={() => setPage("residential")}>Residential</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#" onClick={() => setPage("commercial")}>Commercial</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#" onClick={() => setPage("products")}>Our Products</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#" onClick={() => setPage("contact")}>Contact/Orders</a>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>

        <div class="row">
          <div class="col col-lg-8 col-sm-10 background">
            <Wrapper display={page} value="contact" onChange={handleChange} />
          </div>
        </div>
      </div>
      {/* <Products value={"contact"} onChange={handleChange} /> */}
    </div>
  )
}
export default App;
